import { colors } from '../colors'
export default {
  discountedPriceColor: colors.discountedPrice,
  fullPriceColor: colors.body,
  salePriceColor: colors.active
}
